import React from 'react';
import { useLocation } from 'react-router-dom';
import { Restaurant } from '../../services/restaurantService';
import PlatformFooter from './PlatformFooter';
import RestaurantFooter from './RestaurantFooter';
import { OpeningHoursRow } from './footerUtils';

export type FooterVariant = 'platform' | 'restaurant' | 'auto' | 'auth';

const AUTH_FOOTER_PATHS = new Set(['/signin', '/forgotPassword', '/resetPassword']);

export function isAuthFooterPath(pathname: string): boolean {
  return AUTH_FOOTER_PATHS.has(pathname);
}

export interface FooterProps {
  variant?: FooterVariant;
  restaurant?: Restaurant | null;
  openingHours?: OpeningHoursRow[];
}

/** Restaurant customer pages use the restaurant footer (home, menu, games). */
export function isRestaurantFooterPath(pathname: string): boolean {
  return /^\/restaurants\/[^/]+(\/(menu(\/[^/]+)?|games(\/[^/]+)?))?$/.test(pathname);
}

const Footer: React.FC<FooterProps> = ({ variant = 'auto', restaurant, openingHours }) => {
  const { pathname } = useLocation();
  const resolved =
    variant === 'auto'
      ? isRestaurantFooterPath(pathname)
        ? 'restaurant'
        : isAuthFooterPath(pathname)
          ? 'auth'
          : 'platform'
      : variant;

  if (resolved === 'restaurant') {
    return <RestaurantFooter restaurant={restaurant} openingHours={openingHours} />;
  }

  return <PlatformFooter variant={resolved === 'auth' ? 'auth' : 'default'} />;
};

export default Footer;
